import {
  filterToCanonical
} from "./chunk-U523KRWQ.js";

// src/policy/normalizer.ts
function readStringArray(value) {
  if (!Array.isArray(value)) return [];
  const out = [];
  for (const v of value) {
    if (typeof v === "string" && v.length > 0) out.push(v);
  }
  return out;
}
function normalizeRolesFromClaims(claims) {
  if (!claims) return [];
  const flat = readStringArray(claims.roles);
  let nested = [];
  const ra = claims.realm_access;
  if (ra && typeof ra === "object") {
    nested = readStringArray(ra.roles);
  }
  const merged = [];
  const seen = /* @__PURE__ */ new Set();
  for (const r of [...flat, ...nested]) {
    if (!seen.has(r)) {
      seen.add(r);
      merged.push(r);
    }
  }
  return filterToCanonical(merged);
}
function getCanonicalRoles(profile) {
  return normalizeRolesFromClaims(profile);
}

export {
  normalizeRolesFromClaims,
  getCanonicalRoles
};
//# sourceMappingURL=chunk-2EV5EKYJ.js.map